import React from 'react';
import './DataReviewBanner.css';

interface DataReviewBannerProps {
  locationName?: string;
}

/**
 * Banner component to display when electricity data is under review
 * for locations with mixed data sources
 */
export const DataReviewBanner: React.FC<DataReviewBannerProps> = ({ locationName }) => {
  return (
    <div className="data-review-banner" role="alert">
      <div className="data-review-banner-content">
        <div className="data-review-banner-icon">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-6 w-6" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
            width="20"
            height="20"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
            />
          </svg>
        </div>
        <div className="data-review-banner-text">
          <strong>Data Under Review:</strong> {locationName ? `Electricity data for ${locationName}` : 'Electricity data for this location'} is currently under review due to mixed data sources from multiple utilities. Some results may be inaccurate. This location's municipal utility serves only part of the city, with other utilities serving the remainder, which can cause data inconsistencies.
        </div>
      </div>
    </div>
  );
};

